import Register from "../../components/register/register";

export default function SignUp(){
    return <Register />;
}